import { EntryState } from '@enums/strapiTypesAndOperators'

export const baseURL = `${process.env.ACKO_CMS_URL}/api`
export const latticeBaseURL = `${process.env.ACKO_LATTICE_CMS_URL}/api`
export const headers = {
  Authorization: `Bearer ${process.env.AUTHORIZATION_TOKEN}`,
}
export const latticeHeaders = {
  Authorization: `Bearer ${process.env.LATTICE_CMS_API_TOKEN}`,
}
export const PublicationStatusBasedOnEnv = process.env.ACKO_ENV === 'prod' ? EntryState.Live : EntryState.Preview
